<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb
        :crumbs="[
          $t('menu.reports'),
          $t('reports.supplierContributionStatistics') + $t('text.detail'),
        ]"
      >
      </breadcrumb>
    </div>
    <div class="wrapper table-area">
      <!-- <sticky
        :sticky-top="62"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button type="default" size="mini" @click="download">
              {{ $t("action.download") }}
            </el-button>
          </template>
        </vxe-toolbar>
      </sticky> -->
      <vxe-table
        :data="records"
        :loading="loading"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images" height="40" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        />
        <vxe-table-column
          field="rentQuantity"
          :title="$t('reports.rentQuantity')"
          min-width="100px"
        />
        <vxe-table-column
          field="rentAmount"
          :title="$t('reports.rentAmount')"
          min-width="100px"
        >
          <template v-slot="{ row }">
            {{ row.rentAmount | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="saleQuantity"
          :title="$t('reports.saleQuantity')"
          min-width="100px"
        />

        <vxe-table-column
          field="saleAmount"
          :title="$t('reports.saleAmount')"
          min-width="100px"
        >
          <template v-slot="{ row }">
            {{ row.saleAmount | currency }}
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import Workbench from "@/api/workbench";

export default {
  mixins: [page, table.search],
  components: {},
  data() {
    return {
      records: [],
      loading: false,
    };
  },

  created() {
    const self = this;
    self.loadData();
  },
  methods: {
    loadData() {
      const self = this;
      self.loading = true;
      Workbench.supplierContributionStatisticsDetail(self.$route.query).then(
        function (res) {
          self.loading = false;
          if (res.status === 200) {
            self.records = res.data;
          } else {
            self.sysError();
          }
        }
      );
    },

    // download() {
    //   const self = this;
    //   if (self.records.length == 0) {
    //     this.$message({
    //       message: self.$t("text.noData"),
    //       type: "warning",
    //     });
    //     return;
    //   }
    //   Qa.scheduleStatistics(Util.deleteObjValueIsNull(self.searchForm)).then(
    //     function (res) {
    //       if (res.status === 200) {
    //         self.$message({
    //           message: self.$t("prompt.downloadPrompt"),
    //           type: "success",
    //         });
    //         self.checkedRows = [];
    //         self.$eventHub.$emit("emitDownLoad");
    //       } else {
    //         self.$message.error(self.$t("prompt.downloadErr"));
    //       }
    //     }
    //   );
    // },
  },
};
</script>
<style >
.el-form-item__content {
  height: auto !important;
}
</style>